<template>
  <div class="main">
    <my-header title="课程信息" back-path="/"></my-header>
    <div class="container">
      <div class="top">
        <tab :items="['今日课程','本周课程']" @change="changeView"></tab>
        <div><span v-text="date"></span></div>
      </div>
      <div class="subject">
        <div class="today" v-if="isToday">
          <div class="subject-item" :class="i%2===1&&'gray'" v-for="(s,i) in todaySubject" :key="`today_s_${i}`"
               :coming="isComing(s)&&true">
            <div>
              <span v-text="comm.dateFormat(`2018/01/01 ${s.start}`,'HH:mm')"></span>
              <span v-text="s.name"></span>
              <span>授课老师：</span>
              <span v-text="s.teacher"></span>
            </div>
            <div>
              <span>授课时间：</span>
              <span v-text="comm.dateFormat(`2018/01/01 ${s.start}`,'HH:mm')"></span>
              <span> ~ </span>
              <span v-text="comm.dateFormat(`2018/01/01 ${s.end}`,'HH:mm')"></span>
            </div>
          </div>
          <div v-if="!todaySubject.length" class="none">
            <span>今日暂无课程</span>
          </div>
        </div>
        <div class="week" v-else>
          <div v-for="i in [0,1,2,3,4,5,6,7]" :key="i" :class="i===week&&'selected'">
            <template v-if="i>0">
              <div v-text="comm.getWeek(i)"></div>
              <div v-for="(s,i) in subject[i] || ['--','--','--','--','--','--','--','--']" v-text="s.name || s"
                   :key="`subject_w_${i}`" class="item">
              </div>
            </template>
            <template v-else>
              <div>星期/节次</div>
              <div v-for="(s,i) in subject[i+1] || []" v-text="`第${getUpperNumber(i+1)}节`" :key="`subject_j_w_${i}`"
                   class="item"></div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyHeader from '@/components/HeaderTitle'
import Tab from '@/components/Tab'
import comm from '@/assets/lib/comm'
import { mapState } from 'vuex'
import basic from '@/model/zone'

export default {
  name: 'Subject',
  created () {
    if (!this.zone) {
      basic.getBasicInfo()
    }
  },
  data () {
    return {
      isToday: true,
      date: comm.dateFormat(new Date(), 'yyyy年MM月dd日'),
      comm: comm,
      // todaySubject: [],
      week: (new Date()).getDay() || 7
    }
  },
  computed: {
    ...mapState(['subject', 'zone']),
    todaySubject () {
      if (this.subject[this.week]) {
        return this.subject[this.week]
      } else {
        return []
      }
    }
  },
  components: {
    MyHeader,
    Tab
  },
  mounted () {
    this.interval = comm.timerInClock(() => {
      this.$forceUpdate()
    }, 1, 30)
  },
  methods: {
    changeView (i) {
      this.isToday = (i === 0 && true) || false
    },
    isComing (subject) {
      // 生成当前时间和课程时间
      const start = new Date(comm.dateFormat(new Date(), 'yyyy-MM-dd HH:mm:ss').split(' ')[0] + ' ' + subject.start)
      const end = new Date(comm.dateFormat(new Date(), 'yyyy-MM-dd HH:mm:ss').split(' ')[0] + ' ' + subject.end)
      this.$logger.debugger(comm.dateFormat(new Date(), 'yyyy-MM-dd HH:mm:ss').split(' ')[0] + ' ' + subject.start)
      this.$logger.debugger(end)
      if (new Date() >= start && new Date() <= end) {
        return true
      }
      return false
    },
    getUpperNumber (i) {
      const unit = '零一二三四五六七八九十'
      return unit.split('')[i]
    },
    beforeDestroy () {
      // 清除页面的定时器，定时器主要用于切换当前课程
      this.interval && clearInterval(this.interval)
    }
  }
}
</script>
<style scoped lang="less">
.main {
  .container {
    margin: 65px 20px 20px 20px;
    background-color: white;
    box-shadow: 0px 3px 10px 1px rgba(56, 126, 232, 0.1);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    .top {
      padding: 22px 30px 20px 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div:last-child {
        font-size: 15px;
        font-weight: 600;
        color: rgba(28, 50, 79, 1);
      }
    }
    .subject {
      flex: 1;
      overflow-y: auto;
      .week {
        font-size: 17px;
        font-weight: 500;
        color: rgba(149, 166, 191, 1);
        display: flex;
        justify-content: space-between;
        padding: 10px 30px 10px 30px;
        .item {
          padding: 22px 0px;
          text-align: center;
        }
        .selected {
          color: #39D474;
        }
      }
      .today {
        .gray {
          background-color: #F4F6F9;
        }
        > .subject-item[coming] {
          color: #39D474;
        }
        > .subject-item {
          padding: 0px 30px;
          height: 68px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #1C324F;
          > div:first-child {
            span:first-child {
              margin-right: 50px;
              font-size: 15px;
              font-weight: 600;
            }
            span:nth-child(2) {
              margin-right: 15px;
              font-size: 17px;
              font-weight: 600;
            }
            span:nth-child(3), span:nth-child(4) {
              font-size: 12px;
              font-weight: 400;
            }
          }
          > div:last-child {
            font-size: 13px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>
